import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {DataTransferService} from "@irb-common/services/data-transfer.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {ISecurityCustomCategories} from "@irb/irb-models/irb-models.model";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import { IEvent, IrbSettingsEvents } from '@irb/irb-common/events';
import { AppService } from '@irb/app.service';
import { Subscription } from 'rxjs';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
    selector: 'irb-security-asset-category',
    templateUrl: './security-asset-category.component.html',
    styleUrls: ['./security-asset-category.component.scss']
})
export class SecurityAssetCategoryComponent implements OnInit {
    @ViewChild('customCategoryDropdown') customCategoryDropdown: any; 
    _securityAssetCategoryData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };
    private _isDataLoaded = false;
    private _selectedCategoryName: string = "";
    selectedCustomCategory: IDropdownItem;
    customCategoryLabel: any;
    assetCategoryPlaceHolder = "Uncategorized";
    public customCategories: Array<IDropdownItem> = [];
    private eventSubscription: Subscription;
    addNewCategoryItem: any = {
        button: 'Add new category',
        type: 'assetCategory',
        fromComp: 'SecurityAssetCategoryComponent'
    };

    @Output()
    categoryChanged = new EventEmitter<any>();
    @Input()
    set securityAssetCategoryData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._securityAssetCategoryData = value;
        this.setAssetCategoriesDefaultsData();
    }

    mStarRecommendedCategory: IDropdownItem;

    constructor(public irbEditorsService: IrbEditorsService,
                private dataTransferService: DataTransferService,
                private as: AppService,
                private util: UtilityService,) {
    }

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
        this.irbEditorsService.getCustomCategories().subscribe((customCategories: ISecurityCustomCategories) => {
            let mStarRecommendedCategoryId: any = null;
            if (this._securityAssetCategoryData && this._securityAssetCategoryData.securityData
                && this._securityAssetCategoryData.securityData.length
                && this._securityAssetCategoryData.securityData[0].mStarRecommendedCategoryId) {
                this.mStarRecommendedCategory = {
                    name: '*' + this._securityAssetCategoryData.securityData[0].mStarRecommendedCategoryName,
                    value: this._securityAssetCategoryData.securityData[0].mStarRecommendedCategoryId,
                    class: ['dd-msstar-recommended']
                }
                mStarRecommendedCategoryId = this.mStarRecommendedCategory.value;
            }
            let isMsFound = false;
            customCategories.items.forEach((item: any) => {
                if (item.custCatId === mStarRecommendedCategoryId) {
                    isMsFound = true;
                } else {
                    this.customCategories.push({
                        name: item.custCatName,
                        value: item.custCatId
                    } as IDropdownItem);
                }
            });
            if (!isMsFound)
                this.mStarRecommendedCategory = null;

            this.util.sortByKey(this.customCategories, "name", "asc");
            this.customCategories = this.getDistinctCategories(this.customCategories);
            this.setAssetCategoriesDefaultsData();
        });

        this.customCategoryLabel = this.dataTransferService.EnvironmentSpecificCustomCategory;
    }

    private processEvent(event: IEvent) {
        switch (event.type) {
            case IrbSettingsEvents.ASSET_CATEGORY_UPDATED:
                if (event.data) {
                    if (event.data.type === 'assetCategory' && event.data.fromComp === 'SecurityAssetCategoryComponent') {
                        this.resetCategorySearch(event.data)
                    }
                }
                break;
        }
    }

    onCategoryChanged(event: IDropdownItem) {
        this._selectedCategoryName = event.name.replace('*', '');
        this.categoryChanged.emit(event);
    }

    private getDistinctCategories(categories: Array<IDropdownItem>): Array<IDropdownItem> {
        const distinctCategories: Array<IDropdownItem> = [];
        
        categories.forEach((x: IDropdownItem) => {
            if (x.name && distinctCategories.findIndex(y => x.name === y.name) === -1) {
                distinctCategories.push(x);
            }
        });

        return distinctCategories;
    }

    private setSelectedCategoryDefaults(name: string) {
        if (!name)
            return;
        const msName = '*' + name.replace('*', '');
        if (this.mStarRecommendedCategory && this.mStarRecommendedCategory.name === msName) {
            this.selectedCustomCategory = this.mStarRecommendedCategory;
            this.customCategoryDropdown.setValue(this.selectedCustomCategory);
        } else {
            if (this.customCategories && this.customCategories.length > 0) {
                const customCategorySelected = this.customCategories.find(x => x.name === name);
                this.selectedCustomCategory = customCategorySelected || null;
                this.customCategoryDropdown.setValue(this.selectedCustomCategory);
            }
        }
    }

    setAssetCategoriesDefaultsData() {
        let assetCategoryDefault = "";

        if (this._securityAssetCategoryData) {
            if (this._securityAssetCategoryData.multipleSecurity) {
                assetCategoryDefault = this.getInitialValue("customCategoryName", this._securityAssetCategoryData.securityData);
            } else {
                assetCategoryDefault = this._securityAssetCategoryData.securityData[0].customCategoryName;
            }

            if(assetCategoryDefault === "Various") {
                this.assetCategoryPlaceHolder = assetCategoryDefault;
                this._selectedCategoryName = "";
            } else {
                this._selectedCategoryName = assetCategoryDefault;
            }

            this._isDataLoaded = true;
            this.setSelectedCategoryDefaults(this._selectedCategoryName);
        }
    }

    private getInitialValue(name: string, items: any[]) {
        let inputVal = items[0][name];

        for (let i = 0; i < items.length; i++) {
            const thisVal = items[i][name];

            if (inputVal !== thisVal) {
                inputVal = "Various";
            }
        }

        return inputVal;
    }

    public isValid() {
        return true;
    }

    getItemsForCustomCategoryDropdown(searchString: string) {
        let customCategoriesData: any = DropdownFilterComponent.getFilteredList(searchString, this.customCategories);
        if (this.mStarRecommendedCategory)
            customCategoriesData.unshift(this.mStarRecommendedCategory);
        this.customCategoryDropdown.set(customCategoriesData);
    }

    openNewItemCategoryFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewCategoryItem, dataParam);
        this.as.setToLocal("LAST_TAB_INDEX", 0);
        this.as.fireEvent(IrbSettingsEvents.SHOW, dataParam);
    }

    resetCategorySearch(dataParam: any) {
        let newAddData: any;
        if (dataParam && dataParam.newItems && dataParam.newItems.length !== 0) {
            for (let i=0; i<dataParam.newItems.length; i++){
                newAddData = {
                    value: dataParam.newItems[i].custCatId,
                    name: dataParam.newItems[i].custCatName,
                    versionId: null
                  }
            }
            this.customCategories = this.customCategories.concat(newAddData);
            if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
                this.selectedCustomCategory = dataParam.newItemsForDD[0];
                this.onCategoryChanged(dataParam.newItemsForDD[0])
            }
        }
    }
}
